import React, {useRef, useEffect, useState, createContext, useContext} from "react";
import {ErrorBoundary} from "@unibuddy/error-reporting";

import useAuth from "@unibuddy/machop/Auth/hooks/useAuth";
import {
    AUTH_TRANSFER,
    AUTH_TRANSFER_READY,
    TRANSFER_PARENT_PARAMS,
} from "@unibuddy/machop/Utils/Constants";

const EmbeddedWidgetContext = createContext({});

export function useEmbeddedWidgetProvider() {
    return useContext(EmbeddedWidgetContext);
}

export function EmbeddedWidgetProvider({children}) {
    const [iframeRef, setIFrameRef] = useState();
    return (
        <EmbeddedWidgetContext.Provider value={{setRef: setIFrameRef, iframeRef}}>
            {children}
        </EmbeddedWidgetContext.Provider>
    );
}

export default function EmbeddedWidget({match, location}) {
    const iframeRef = useRef();
    const query = new URLSearchParams(location.search);
    let url = `${ONIX_URL}/embed/${match.params.universitySlug}/colour/123456/`;
    const {authState, setAuth} = useAuth();

    if (query.get("chatWith")) {
        url += `inbox/start/${query.get("chatWith")}`;
    } else if (query.get("readMore")) {
        const buddyType = query.get("type") === "staff" ? "staff" : "students";
        url += `buddies/${buddyType}/${query.get("readMore")}`;
    } else {
        url += "buddies/students";
    }
    const [listenerReady, setListenerReady] = useState(false);
    const {setRef} = useEmbeddedWidgetProvider();

    useEffect(() => {
        setRef(iframeRef);
    }, [setRef]);

    useEffect(() => {
        if (authState) {
            const listener = ({data}) => {
                if (data.name === AUTH_TRANSFER_READY) {
                    if (iframeRef.current) {
                        iframeRef.current.contentWindow.postMessage(
                            {name: AUTH_TRANSFER, value: authState},
                            ONIX_URL,
                        );
                    }
                }

                // Sending the parent website url (i.e. opendays) down to the onix widget
                // to ensure that when we use TrackOpenDays analytics we can correctly know where
                // we are sending it from.
                if (iframeRef.current) {
                    iframeRef.current.contentWindow.postMessage(
                        {
                            name: TRANSFER_PARENT_PARAMS,
                            value: {
                                universitySlug: match.params.universitySlug,
                                openDayId: match.params.id,
                            },
                        },
                        ONIX_URL,
                    );
                }

                if (data.name === AUTH_TRANSFER) {
                    // We set the value when its transferred to setAuth, which means
                    // that we will always have an up to date state of whether
                    // a user is logged in or not
                    setAuth(data.value);
                }
            };

            window.addEventListener("message", listener);

            setListenerReady(true);
            return () => window.removeEventListener("message", listener);
        }
    }, [authState, setAuth, iframeRef, match]);

    return !listenerReady ? (
        "Loading"
    ) : (
        <ErrorBoundary>
            <iframe ref={iframeRef} height="100%" width="100%" src={url} />
        </ErrorBoundary>
    );
}
